import { forwardRef } from 'react';

import { mergeSlotProps } from '@mui/material/utils';
import { DateField } from '@mui/x-date-pickers/DateField';
import { DateTimeField } from '@mui/x-date-pickers/DateTimeField';
import { usePickerContext } from '@mui/x-date-pickers/hooks';
import { TimeField } from '@mui/x-date-pickers/TimeField';

function createMobilePickerField(Field) {
  return forwardRef(function MobilePickerField({ onKeyDown, readOnly = true, slotProps, ...props }, ref) {
    const { setOpen, triggerStatus } = usePickerContext();
    const handleClick = event => {
      if (
        !event.defaultPrevented &&
        !event.target.closest('button, [role="button"]') &&
        !props.disabled &&
        triggerStatus === 'enabled'
      ) {
        // Label activation would forward a second click to the hidden input.
        event.preventDefault();
        setOpen(true);
      }
    };
    const handleKeyDown = event => {
      onKeyDown?.(event);
      if (
        !event.defaultPrevented &&
        !event.target.closest('button, [role="button"]') &&
        !props.disabled &&
        triggerStatus === 'enabled' &&
        [' ', 'Enter'].includes(event.key)
      ) {
        event.preventDefault();
        setOpen(true);
      }
    };
    return (
      <Field
        {...props}
        onKeyDown={handleKeyDown}
        readOnly={readOnly}
        ref={ref}
        slotProps={{
          ...slotProps,
          textField: ownerState => {
            const textFieldProps =
              typeof slotProps?.textField === 'function' ? slotProps.textField(ownerState) : slotProps?.textField;
            return {
              ...textFieldProps,
              slotProps: {
                ...textFieldProps?.slotProps,
                root: mergeSlotProps(textFieldProps?.slotProps?.root, { onClick: handleClick }),
              },
            };
          },
        }}
      />
    );
  });
}

export const MobileDatePickerField = createMobilePickerField(DateField);
export const MobileDateTimePickerField = createMobilePickerField(DateTimeField);
export const MobileTimePickerField = createMobilePickerField(TimeField);
